import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit, OnDestroy } from '@angular/core';

declare var MercadoPago: any;

@Component({
    selector: 'mercadopago-checkout-button',
    templateUrl: './mercadopago-checkout-button.component.html',
    styleUrls: ['./mercadopago-checkout-button.component.scss']
})
export class MercadopagoCheckoutButtonComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() publicKey: string;
    @Input() preferenceId: string;
    @Input() amount: number | string;
    @Output() onClose = new EventEmitter<void>();

    private mpInstance: any;
    private observer: MutationObserver;
    private messageListener: (event: MessageEvent) => void;

    constructor() { }

    ngAfterViewInit(): void {
        if (this.publicKey && this.preferenceId) {
            this.renderButton();
        }
        
        // Listener global de mensajes como último recurso para detectar cierre de MP
        this.messageListener = (event: MessageEvent) => {
            if (event.data && typeof event.data === 'string' && (event.data.includes('close') || event.data.includes('mpp-close'))) {
                console.log('DEBUG: MercadopagoCheckoutButtonComponent -> Mensaje de cierre detectado via window.postMessage');
                this.handleClose();
            } else if (event.data && event.data.action === 'close') {
                console.log('DEBUG: MercadopagoCheckoutButtonComponent -> Acción de cierre detectada via window.postMessage');
                this.handleClose();
            }
        };
        window.addEventListener('message', this.messageListener);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes['preferenceId'] || changes['amount'] || changes['publicKey']) && !changes['preferenceId']?.firstChange) {
            this.renderButton();
        }
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.messageListener) {
            window.removeEventListener('message', this.messageListener);
        }
        this.clearContainer();
    }

    private renderButton(): void {
        if (!this.publicKey || !this.preferenceId) return;

        // Small delay to ensure the container is ready in the DOM
        setTimeout(() => {
            this.clearContainer();

            try {
                if (!this.mpInstance || (this.mpInstance && this.publicKey !== this.mpInstance.publicKey)) {
                    this.mpInstance = new MercadoPago(this.publicKey, {
                        locale: 'es-AR'
                    });
                }

                this.mpInstance.checkout({
                    preference: {
                        id: this.preferenceId
                    },
                    render: {
                        container: '#containerMP',
                        label: 'Pagar $' + this.amount,
                        type: 'wallet',
                    },
                    callbacks: {
                        onClose: () => {
                            console.log('DEBUG: MercadopagoCheckoutButtonComponent -> Callback onClose de MP disparado.');
                            this.handleClose();
                        },
                        onReady: () => {
                            console.log('DEBUG: MercadopagoCheckoutButtonComponent -> Checkout de MP listo.');
                        },
                        onError: (error) => {
                            console.error('DEBUG: MercadopagoCheckoutButtonComponent -> Error de MP:', error);
                            this.handleClose(); // Cerramos si hay error para no quedar bloqueados
                        }
                    }
                });
                
                // Fallback con MutationObserver por si el callback oficial falla en ciertos navegadores
                let modalFueAbierto = false;
                if (this.observer) {
                    this.observer.disconnect();
                }
                
                this.observer = new MutationObserver((mutations) => {
                    const overlay = document.querySelector('.mercadopago-checkout-p-container');
                    if (overlay) {
                        modalFueAbierto = true;
                    } else if (modalFueAbierto) {
                        console.log('DEBUG: MercadopagoCheckoutButtonComponent -> Overlay MP cerrado detectado por Observer.');
                        this.handleClose();
                        modalFueAbierto = false;
                    }
                });
                this.observer.observe(document.body, { childList: true, subtree: true });
            } catch (error) {
                console.error('Error rendering Mercado Pago button:', error);
            }
        }, 100);
    }

    private handleClose(): void {
        this.clearContainer();
        this.onClose.emit();
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private clearContainer(): void {
        const container = document.getElementById('containerMP');
        if (container) {
            container.innerHTML = '';
        }
    }
}
